import { DialogActionsBar as KDialogActionsBar } from "@progress/kendo-react-dialogs";

// FIXME: fix once export is corrected
import type { DialogActionsBarProps as KDialogActionsBarProps } from "@progress/kendo-react-dialogs/dist/npm/DialogActionsBar";

import "./Dialog.scss";

export const DialogActionsBar = function render(props: KDialogActionsBarProps) {
  return <KDialogActionsBar {...props} />;
};
